module.exports = __webpack_public_path__ + "static/media/v_push-services-pa2.7fca4065.png";